const routes = {
  PROFILE: "/profile",
  CONSULTATION: "/consultation-request",
  SERVERERROR: "/server-error",
  PROFILENOTFOUND:"/profile-not-found",
  UNDERCONSTRUCTION: "/under-construction",
  PREVIEW:"/",
  PREVIEWWITHAGENTCODE:"/:id",
  POLICY: "/policy",
  INSURANCEPOLICY: "/insurance-policy",
  INSURANCEPOLICYDetails: "/insurance-policy-details/:id",
  DASHBOARD:"/dashboard",

  UNITLINK: "/unitlink",
  UNITLINKUPDATE: "/unitlink-update/:id",
  UNITLINKISSUING: "/unitlink-issuing",
  UNITLINKISSUINGUPDATE: "/unitlink-issuing/:id",
  INSTALLMENT: "/installment/:id",
  
  INSURANCERATE: "/insurance-rate",
  PROJECTS: "/projects",

  UNIVERSAL: "/universal/:id",
  UNIVERSALWITHTOKEN: "/universal/:id/:token",
  UNIVERALUPDATE: "/universal-update/:id",


  // UNIVERALDETAILS:"/universal-details/:id",
  UNIVERALISSUING:"/universal-issuing",
  UNIVERALISSUINGUPDATE:"/universal-issuing/:id",
  
  INQUERY: "/inquery",
  INQUERYUPDATE: "/inquery-update/:id",

  ISSUING: "/issuing",
  ISSUINGUPDATE: "/issuing/:id",

  OFFERSLIST:"/insurance-universal-offers",
  OFFERSDETAILS:"/insurance-universal-offers/:id",
  PREPAYMENT: "/pre-payment",
  TRANSACTIONS: "/transactions",
  PAYMENTSUCCESS:"/payment-success",
  PROCESSCOMPLETE: "/process-complete/:id",
};

export default routes;
